module.exports = __webpack_public_path__ + "img/readMore.078f6019.svg";